import React from 'react';

const CodeInput = ({ code, onCodeChange }) => {
  return (
    <div className="grow h-full min-h-100 lg:min-h-0">
      <textarea
        value={code}
        onChange={(e) => onCodeChange(e.target.value)}
        placeholder="Paste your code here..."
        className="w-full h-full p-4 bg-slate-800 border border-slate-700 rounded-lg text-slate-300 font-mono text-sm resize-none focus:outline-none focus:ring-2 focus:ring-cyan-500 transition-colors"
        spellCheck="false"
      />
    </div>
  );
};

export default CodeInput;
